export default __webpack_public_path__ + "static/media/nft9.89881bc1.png";